const tableConfigProps = {
    emptyStateText: 'Nie udało się załadować danych',
    isLoading: false,
};

export const INSTALLMENTS_MODAL_CONFIG = {
    title: 'Koszty spłaty w ratach',
    subtitle:
        'Poniżej znajdziesz warunki spłaty dla różnych kwot transakcji po 30 dniach od dokonania zakupu.',
    tables: [
        {
            id: 1,
            tableProps: {
                ...tableConfigProps,
                columns: [
                    {
                        field: 'amount',
                        label: '10,00 zł - 199,99 zł',
                    },
                    {
                        field: 'amount',
                        label: '',
                    },
                ],
                rows: [
                    {
                        id: '1',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Liczba rat',
                            },
                            { columnName: 'number', value: '4' },
                        ],
                    },
                    {
                        id: '2',
                        cells: [
                            { columnName: 'text', value: 'Pierwsze 30 dni' },
                            { columnName: 'number', value: '0 zł' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Całkowity koszt w ratach',
                            },
                            { columnName: 'number', value: '15,00%' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            { columnName: 'text', value: 'RRSO' },
                            { columnName: 'number', value: '97,9%' },
                        ],
                    },
                ],
            },
        },
        {
            id: 2,
            tableProps: {
                ...tableConfigProps,
                columns: [
                    {
                        field: 'amount',
                        label: '200,00 zł - 399,99 zł',
                    },
                    {
                        field: 'amount',
                        label: '',
                    },
                ],
                rows: [
                    {
                        id: '1',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Liczba rat',
                            },
                            { columnName: 'number', value: '5' },
                        ],
                    },
                    {
                        id: '2',
                        cells: [
                            { columnName: 'text', value: 'Pierwsze 30 dni' },
                            { columnName: 'number', value: '0 zł' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Całkowity koszt w ratach',
                            },
                            { columnName: 'number', value: '17,00%' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            { columnName: 'text', value: 'RRSO' },
                            { columnName: 'number', value: '89,7%' },
                        ],
                    },
                ],
            },
        },
        {
            id: 3,
            tableProps: {
                emptyStateText: 'Nie udało się załadować danych',
                isLoading: false,
                columns: [
                    {
                        field: 'amount',
                        label: '400,00 zł - 799,99 zł',
                    },
                    {
                        field: 'amount',
                        label: '',
                    },
                ],
                rows: [
                    {
                        id: '1',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Liczba rat',
                            },
                            { columnName: 'number', value: '6' },
                        ],
                    },
                    {
                        id: '2',
                        cells: [
                            { columnName: 'text', value: 'Pierwsze 30 dni' },
                            { columnName: 'number', value: '0 zł' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Całkowity koszt w ratach',
                            },
                            { columnName: 'number', value: '18,00%' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            { columnName: 'text', value: 'RRSO' },
                            { columnName: 'number', value: '79,0%' },
                        ],
                    },
                ],
            },
        },
        {
            id: 4,
            tableProps: {
                ...tableConfigProps,
                columns: [
                    {
                        field: 'amount',
                        label: '800,00 zł - 1 399,99 zł',
                    },
                    {
                        field: 'amount',
                        label: '',
                    },
                ],
                rows: [
                    {
                        id: '1',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Liczba rat',
                            },
                            { columnName: 'number', value: '7' },
                        ],
                    },
                    {
                        id: '2',
                        cells: [
                            { columnName: 'text', value: 'Pierwsze 30 dni' },
                            { columnName: 'number', value: '0 zł' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Całkowity koszt w ratach',
                            },
                            { columnName: 'number', value: '18,00%' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            { columnName: 'text', value: 'RRSO' },
                            { columnName: 'number', value: '66,6%' },
                        ],
                    },
                ],
            },
        },
        {
            id: 5,
            tableProps: {
                ...tableConfigProps,
                columns: [
                    {
                        field: 'amount',
                        label: '1 400,00 zł - 1 999,99 zł',
                    },
                    {
                        field: 'amount',
                        label: '',
                    },
                ],
                rows: [
                    {
                        id: '1',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Liczba rat',
                            },
                            { columnName: 'number', value: '8' },
                        ],
                    },
                    {
                        id: '2',
                        cells: [
                            { columnName: 'text', value: 'Pierwsze 30 dni' },
                            { columnName: 'number', value: '0 zł' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Całkowity koszt w ratach',
                            },
                            { columnName: 'number', value: '18,00%' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            { columnName: 'text', value: 'RRSO' },
                            { columnName: 'number', value: '57,5%' },
                        ],
                    },
                ],
            },
        },
        {
            id: 6,
            tableProps: {
                ...tableConfigProps,
                columns: [
                    {
                        field: 'amount',
                        label: '2 000,00 zł - 2 499,99 zł',
                    },
                    {
                        field: 'amount',
                        label: '',
                    },
                ],
                rows: [
                    {
                        id: '1',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Liczba rat',
                            },
                            { columnName: 'number', value: '9' },
                        ],
                    },
                    {
                        id: '2',
                        cells: [
                            { columnName: 'text', value: 'Pierwsze 30 dni' },
                            { columnName: 'number', value: '0 zł' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Całkowity koszt w ratach',
                            },
                            { columnName: 'number', value: '18,00%' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            { columnName: 'text', value: 'RRSO' },
                            { columnName: 'number', value: '50,6%' },
                        ],
                    },
                ],
            },
        },
        {
            id: 7,
            tableProps: {
                ...tableConfigProps,
                columns: [
                    {
                        field: 'amount',
                        label: '2 500,00 zł - 2 999,99 zł',
                    },
                    {
                        field: 'amount',
                        label: '',
                    },
                ],
                rows: [
                    {
                        id: '1',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Liczba rat',
                            },
                            { columnName: 'number', value: '10' },
                        ],
                    },
                    {
                        id: '2',
                        cells: [
                            { columnName: 'text', value: 'Pierwsze 30 dni' },
                            { columnName: 'number', value: '0 zł' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Całkowity koszt w ratach',
                            },
                            { columnName: 'number', value: '17,00%' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            { columnName: 'text', value: 'RRSO' },
                            { columnName: 'number', value: '42,3%' },
                        ],
                    },
                ],
            },
        },
        {
            id: 8,
            tableProps: {
                ...tableConfigProps,
                columns: [
                    {
                        field: 'amount',
                        label: '3 000,00 zł - 3 499,99 zł',
                    },
                    {
                        field: 'amount',
                        label: '',
                    },
                ],
                rows: [
                    {
                        id: '1',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Liczba rat',
                            },
                            { columnName: 'number', value: '11' },
                        ],
                    },
                    {
                        id: '2',
                        cells: [
                            { columnName: 'text', value: 'Pierwsze 30 dni' },
                            { columnName: 'number', value: '0 zł' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Całkowity koszt w ratach',
                            },
                            { columnName: 'number', value: '17,00%' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            { columnName: 'text', value: 'RRSO' },
                            { columnName: 'number', value: '38,2%' },
                        ],
                    },
                ],
            },
        },
        {
            id: 9,
            tableProps: {
                ...tableConfigProps,
                columns: [
                    {
                        field: 'amount',
                        label: '3 500,00 zł - 8 000,00 zł',
                    },
                    {
                        field: 'amount',
                        label: '',
                    },
                ],
                rows: [
                    {
                        id: '1',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Liczba rat',
                            },
                            { columnName: 'number', value: '12' },
                        ],
                    },
                    {
                        id: '2',
                        cells: [
                            { columnName: 'text', value: 'Pierwsze 30 dni' },
                            { columnName: 'number', value: '0 zł' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            {
                                columnName: 'text',
                                value: 'Całkowity koszt w ratach',
                            },
                            { columnName: 'number', value: '16,00%' },
                        ],
                    },
                    {
                        id: '3',
                        cells: [
                            { columnName: 'text', value: 'RRSO' },
                            { columnName: 'number', value: '32,6%' },
                        ],
                    },
                ],
            },
        },
    ],
};
